var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1833 17.9712L15.106 14.894L15.0621 14.85H15H3.33329C2.9151 14.85 2.56065 14.7027 2.26186 14.404C1.96308 14.1052 1.81612 13.7511 1.81663 13.3335V13.3334V3.33336C1.81663 2.91516 1.96391 2.56071 2.26269 2.26192C2.56148 1.96314 2.91559 1.81618 3.33311 1.81669H3.33329H16.6666C17.0848 1.81669 17.4393 1.96397 17.7381 2.26275C18.0368 2.56154 18.1838 2.91565 18.1833 3.33317V3.33336V17.9712ZM16.5617 14.3781L16.8166 14.6274V14.2709V3.33336V3.18336H16.6666H3.33329H3.18329V3.33336V13.3334V13.4834H3.33329H15.6471L16.5617 14.3781ZM14.85 10.15V11.5167H5.14996V10.15H14.85ZM14.85 7.65002V9.01669H5.14996V7.65002H14.85ZM14.85 5.15002V6.51669H5.14996V5.15002H14.85Z",
    fill: "#121212",
    stroke: "#121212",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.118022b2df7f5024d10e1345871917e3.svg";
export { ForwardRef as ReactComponent };